interface CustomProgressBarProps {
  currentQuestion: number;
  totalQuestions: number;
}

export const CustomProgressBar: React.FC<CustomProgressBarProps> = ({
  currentQuestion,
  totalQuestions,
}) => {
  const percentage = (currentQuestion / totalQuestions) * 100;

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#9FA8DA",
        borderRadius: "50px",
      }}
    >
      <div
        className="progress-bar"
        style={{
          width: `${percentage}%`,
          backgroundColor: "#3F51B5",
          height: "12px",
          borderRadius: "50px",
          textAlign: "center",
          color: "white",
        }}
      ></div>
    </div>
  );
};
